import { render, staticRenderFns } from "./DdsCalculate.vue?vue&type=template&id=446857af&"
import script from "./DdsCalculate.vue?vue&type=script&lang=js&"
export * from "./DdsCalculate.vue?vue&type=script&lang=js&"
import style0 from "./DdsCalculate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports